import VehicleAutoSuggest
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleModel/components/VehicleAutoSuggest";
import CheckOrderInputContainer from "@CheckOrder/components/MainSection/CheckOrderInputContainer";
import React from "react";
import {
    JadrolinijaVehicleModelType
} from "@CheckOrder/features/addons/features/jadrolinija/types/JadrolinijaVehicleModel.type";
import CheckOrderErrorLabel from "@CheckOrder/components/MainSection/CheckOrderErrorLabel";
import {useTranslation} from "@Translation/hooks/useTranslation";

interface VehicleModelProps {
    selectedVehicle: JadrolinijaVehicleModelType,
    setVehicle: (value: JadrolinijaVehicleModelType) => void
    autoSuggestModels: JadrolinijaVehicleModelType[],
    showErrors: boolean,
}

function VehicleModel({selectedVehicle, setVehicle, autoSuggestModels, showErrors}: VehicleModelProps) {
    const {
        title: titleLabel,
    } = useTranslation("check_order.addons.JADL.vehicle.model")

    return (
        <CheckOrderInputContainer label={titleLabel}>
            <VehicleAutoSuggest
                selectedVehicle={selectedVehicle}
                setVehicle={setVehicle}
                models={autoSuggestModels ?? []}
            />
            {autoSuggestModels && !selectedVehicle && showErrors && (
                <CheckOrderErrorLabel
                    error="You must select your vehicle model"
                    isAbsolute
                />
            )}
        </CheckOrderInputContainer>
    )
}

export default VehicleModel